export enum pageKind {
    FullNavbar = 1,
    Navbar = 2,
    NoNavbar = 3 
}
